<template>
  <div>
    <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center;    display: flex;
    justify-content: space-between; margin-top: 20px;">
      <v-flex xm12 lg12>
        <v-data-table
            :headers="headers"
            :items="BlockedUserList"
            class="elevation-1"
            v-model="BlockedUsers"
            item-key="id"
            :loading="loaders.blocked_incident_user_list_loader"
            :pagination.sync="pagination"
            :rows-per-page-items="[10, 20, 50, 100]"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left" v-if="props.item.first_name">
              {{
                props.item.first_name +
                " " + props.item.last_name
              }}
            </td>
            <td v-else>{{ " - " }}</td>

            <td class="text-xs-left" v-if="props.item.email"> {{ props.item.email }}</td>
            <td v-else>{{ " - " }}</td>

            <td class="text-xs-left" v-if="props.item.count"> {{ props.item.count }}</td>
            <td v-else>{{ " - " }}</td>

            <td>
              <router-link :to="{name:'restrictedUserIncidents',params:{id: props.item.user_id}}">
                <v-btn color="primary">
                  View Reported Incidents
                </v-btn>
              </router-link>
            </td>


          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-snackbar
        v-model="snackbar.display"
        :color="snackbar.color"
        :top="snackbar.top"
        :bottom="snackbar.bottom"
        :left="snackbar.left"
        :right="snackbar.right"
        :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.display = false">
        <v-icon right color="white"> close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "BlockedUserList",
  watch: {
    pagination: {
      handler() {
        this.getBlockedIncidentUsers();
      },
    },
  },
  data() {
    return {
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Email',
          value: 'email',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Count',
          value: 'count',
          sortable: false,
          align: 'left'
        },
        {
          text: "Action",
          value: 'action',
          sortable: false,
          align: 'left'
        }
      ],
      pagination: {sortBy: "created_at", descending: false, rowsPerPage: 10},
      loaders: {
        blocked_incident_user_list_loader: false,
      },
      BlockedUserList: [],
      BlockedUsers: [],
    }
  },
  methods: {
    getBlockedIncidentUsers() {
      this.loaders.blocked_incident_user_list_loader = true;
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-blocked-incident-users`, {
        params: this.pagination}).then((response) => {
        if (response.data.status == 1) {
          this.loaders.blocked_incident_user_list_loader = false;
          this.BlockedUserList = response.data.data;
        } else if (response.data.status == 0) {
          this.loaders.blocked_incident_user_list_loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        console.warn(error);
        this.loaders.blocked_incident_user_list_loader = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    }
  }
}
</script>

<style scoped>

</style>
